import Typography from "@material-ui/core/Typography";
import React from "react";
import Box from "@material-ui/core/Box";
import {ReactComponent as PoweredByBoost} from "../poweredByBoost.svg"
import {makeStyles} from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    footerPanel: {
        width: "250px",
        marginTop: '30px',
        paddingBottom: theme.spacing(2)
    },
}));

export default function DrawerFooter() {
    // const classes = 
    useStyles();
    return (
        <React.Fragment>

            <Box className={'footerPanel'} display="flex" alignItems="center"
                 justifyContent="center">
                <div>
                    <Typography variant="body2" color="textSecondary" align="center">
                        <PoweredByBoost/>
                    </Typography>
                </div>
            </Box>
        </React.Fragment>
    );
}
